export default function ServicesHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#050810] overflow-hidden">
      {/* Pure CSS gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#050810] via-[#0a0e1f] to-[#050810]"></div>
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full bg-[#d4af37]/6 blur-[120px] pointer-events-none"></div>

      {/* Grid overlay */}
      <div className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: "linear-gradient(rgba(212,175,55,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(212,175,55,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px"
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#d4af37]/30 bg-[#d4af37]/10 mb-8">
          <span className="text-[#d4af37] text-xs font-semibold tracking-widest uppercase">Our Services</span>
        </div>
        <h1 className="text-5xl md:text-7xl font-black text-white leading-tight mb-6">
          Everything You Need to<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#f0d060]">Win Online</span>
        </h1>
        <p className="text-white/50 text-lg max-w-xl mx-auto leading-relaxed">
          From design to development to optimization — we handle every aspect of your digital presence so you can focus on running your business.
        </p>
      </div>
    </section>
  );
}
